import Vue from "vue";

Vue.component("thresholds-search-results", {
	props: ["searchResults"],
	data() {
		return {
			labels: {
				thresholdReciprocityWarningMessage: window.labels.thresholdReciprocityWarningMessage,
				levelsOfGovernment: window.labels.levelsOfGovernment,
			},
			isOpen: null,
		};
	},
	methods: {
		computeTableWidth: function (party) {
			const columnWidth = 200;
			let width = 400;
			party.thresholdNotifications.forEach(item => {
				console.log(item);
				width += ((item.types.length * item.perTypeNotificationCount) * columnWidth);
			});

			return width;
		}
	},
	template: `
		<div>
			<b-collapse
				class="card mb-2"
				animation="slide"
				v-for="(party, index) of searchResults.parties"
				:key="'party-' + index"
				:open="isOpen == index"
				@@open="isOpen = index">
			<template #trigger="props">
				<div class="card-header pt-1 pb-1" role="button">
					<p class="card-header-title">
						{{ party.name }}
					</p>
				</div>
			</template>
			<div class="card-content">
				<div class="content">
					<div class="advanced-search-threshold-scroller">
						<div class="b-table">
							<div class="table-wrapper has-mobile-cards has-sticky-header"
								 :style="'width:' + computeTableWidth(party) + 'px'">
								<table class="table is-striped is-hoverable table-bordered">
									<thead>
										<tr>
											<th rowspan="3" class="advanced-search-threshold-column-annex">
												{{ labels.levelsOfGovernment }}
											</th>
											<th v-for="thresholdNotification in party.thresholdNotifications"
												:key="'thresholdNotification-' + party.id + '-' + thresholdNotification.id"
												:colspan="(thresholdNotification.types.length * thresholdNotification.perTypeNotificationCount)">												
												<span v-html="thresholdNotification.message"></span>
											</th>
										</tr>
										<tr>
											<template v-for="thresholdNotification in party.thresholdNotifications">
												<th v-for="thresholdNotificationType in thresholdNotification.types"
													:key="'thresholdNotification-type-' + party.id + '-' + thresholdNotification.id + '-' + thresholdNotificationType.type"
													:colspan="thresholdNotificationType.currencyCodes.length + 1">
													{{ thresholdNotificationType.type }}
												</th>
											</template>
										</tr>
										<tr>
											<template v-for="thresholdNotification in party.thresholdNotifications">
												<template v-for="type in thresholdNotification.types">
													<th class="advanced-search-threshold-column-sdr has-text-right">
														<div class="th-wrap is-numeric">
															<span class="is-relative"> SDR </span>
														</div>
													</th>
													<template v-for="currency in type.currencyCodes">
														<th class="advanced-search-threshold-column-currency has-text-right">
															<div class="th-wrap is-numeric">
																<span
																	class="is-relative"> {{ currency }} </span>
															</div>
														</th>
													</template>
												</template>
											</template>
										</tr>
									</thead>
									<tbody>
										<tr v-for="annex in party.annexes" :key="'annex-' + party.id + '-'  + annex.id">
											<td v-html="annex.name"></td>
											<td v-for="(value, index) in annex.values"
												:key="'annex-value-' + annex.id + '-' + index"
												:class="{'has-text-centered': true, 'annex-has-reciprocity': annex.hasReciprocity}">
												<span v-html="value"></span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
	
						<template v-if="party.reciprocities">
							<b-collapse :open="false">
								<template #trigger>
									<i class="fas fa-exclamation-triangle fa-1-5x has-text-danger mt-3 mr-2"></i>
									<i style="font-weight: bold">{{ labels.thresholdReciprocityWarningMessage }}</i>
								</template>
								<div class="notification">
									<div class="content">
										<div v-for="reciprocity in party.reciprocities" :key="reciprocity.annex">
											<div v-html="reciprocity.annexMessage" class="mb-4"></div>											
											<annex-notes :level="0" :notes="reciprocity.reciprocityNotes"
														 additional-classes="has-background-white p-4"></annex-notes>
											<div class="horizontal-spacer-10"></div>
											<div v-html="reciprocity.homePartyAnnexMessage" class="mb-2"></div>
											<b-collapse :open="false">
												<template #trigger>
													<div v-html="reciprocity.annexNotesMessage" class="mb-2"></div>
												</template>
												<div class="notification">
													<div class="content">
														<annex-notes :level="0" :notes="reciprocity.annexNotes"
																	 additional-classes="has-background-white p-4"></annex-notes>
													</div>
												</div>
											</b-collapse>
										</div>
										<template v-if="party.annex7Message">
											<b-collapse :open="false">
												<template #trigger>
													<div v-html="party.annex7Message" class="mb-2"></div>
												</template>
												<div class="notification">
													<div class="content">
														<annex-notes :level="0" :notes="party.annex7Notes"
																	 additional-classes="has-background-white p-4"></annex-notes>
													</div>
												</div>
											</b-collapse>
										</template>
									</div>
								</div>
							</b-collapse>
							<div class="horizontal-spacer-20"></div>
						</template>
					</div>
				</div>
			</div>
			</b-collapse>
		</div>
	`
});